import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { grey } from './colors';
import { buildPaletteFromMetadata, type PaletteTokenMetadata, type Token } from './panw-palette/token-metadata';

const borderTokens = [
  { propertyPath: 'bold', tokenName: '--semantic-border-bold' },
  { propertyPath: 'emphasized', tokenName: '--semantic-border-emphasized' },
  { propertyPath: 'default', tokenName: '--semantic-border-default' },
  { propertyPath: 'disabled', tokenName: '--semantic-border-disabled' },
  { propertyPath: 'highlight', tokenName: '--semantic-border-highlight' },
] satisfies Token[];

export const borderTokenMetadata: PaletteTokenMetadata = {
  componentName: 'border',
  tokens: borderTokens,
};

export const border = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['border'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata(borderTokens, tokens);
  }

  return mode === 'light'
    ? {
        bold: grey[300],
        emphasized: grey[150],
        default: grey[150],
        // not used unless panwRebrandStubYear is true, but we need to keep the key for backwards compatibility
        disabled: grey[150],
        highlight: grey[150],
      }
    : {
        bold: grey[600],
        emphasized: grey[150],
        default: grey[850],
        // not used unless panwRebrandStubYear is true, but we need to keep the key for backwards compatibility
        disabled: grey[850],
        highlight: grey[850],
      };
};
